// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"magazine__wrapper__30PIj","figure":"magazine__figure__2ZHIu","noTouch":"magazine__noTouch__1uONT","magazine":"magazine__magazine__3RhhK"};